import React from 'react'
import Yup from './../../../helpers/custom-yup'
import AnchorButton from './../../../components/buttons/anchor-button.component'
import { Formik } from 'formik'
import { CheckboxToggleInput } from '../../../components/form-components'

class AcceptTermsComponent extends React.Component {
	constructor(props) {
		super(props)

		this.formRef = React.createRef()
		this.renderFormik = renderFormik.bind(this)
	}

	componentDidMount() {
		this.props.getFormRef(this.formRef.current)
	}

	render() {
		return (
			<Formik
				ref={this.formRef}
				validationSchema={schema}
				render={this.renderFormik}
				initialValues={initialValues}
				onSubmit={this.props.onSubmit}
			/>
		)
	}
}

const initialValues = {
	acceptTerms: false
}

const schema = Yup.object().shape({
	acceptTerms: Yup.mixed()
		.oneOf([true], 'Aceite os termos e condições de Uso')
		.required('Aceite os termos e condições de Uso')
})

function renderFormik(props) {
	return (
		<div>
			<p>
				Declaro que li e concordo com os{' '}
				<AnchorButton href="/regulamento" noStyle targetBlank>
					termos e condições de uso
				</AnchorButton>{' '}
				e com o{' '}
				<AnchorButton href="/politica-de-privacidade" noStyle targetBlank>
					termo de privacidade
				</AnchorButton>{' '}
				para compra de passagens do programa Muviflex e que o trecho de ida e volta, o dia e o horário da viagem estão corretos
			</p>
			<CheckboxToggleInput id="acceptTerms" {...props} />
		</div>
	)
}

export default AcceptTermsComponent
